import { createContext, ReactElement, ReactNode, RefObject } from 'react';

import { Defaultize } from '../../types';
import { BraxModal, BraxModalProps } from '../BraxModal';
import { BraxNotice, BraxNoticeProps } from '../BraxNotice';

export type CreateModalProps = Defaultize<BraxModalProps, typeof BraxModal.defaultProps>;

export type CreateNoticeProps = Defaultize<BraxNoticeProps, typeof BraxNotice.defaultProps>;

export type CreateCustomModalNode = ReactElement<{ open?: boolean, onClose?: () => void }, any>;

const ModalsContext = createContext<{
    ref: RefObject<HTMLElement>,
    create: (modal: CreateModalProps) => () => void,
    notice: (notice: CreateNoticeProps) => () => void,
    custom: (node: CreateCustomModalNode) => () => void
}>({
    ref: { current: null },
    create: () => () => {},
    notice: () => () => {},
    custom: () => () => {}
});

ModalsContext.displayName = 'ModalsContext';

export default ModalsContext;
